/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import L from "leaflet";
import dayjs from "dayjs";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import { CustomInputWithController } from "../../../Core/Components/CustomInput";
import { PopoverDropdown } from "../../../Core/Components/CustomDropdown";
import useHubStationOnAdd from "../../../Utils/useHubStationOnAdd";
import { LOCATION_TYPE } from "../../Location/Data";
import getLocationType from "../../../Utils/getLocationType";
import { client } from "../../../Utils/axiosClient";
import {
  getAllLocationsV3,
  getGlobalLocations,
} from "../../../Redux/APIs/locationsAPI";
import { getOverallSummary, getTripsV3 } from "../../../Redux/APIs/tripsAPI";

const LabelAndInput = ({
  label,
  control,
  formState,
  name,
  placeholder,
  rules,
  focus,
  setFocus,
  isFieldDisabled,
}) => {
  return (
    <div className="">
      <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
        {label}
      </p>
      <CustomInputWithController
        intent="primary"
        control={control}
        formState={formState}
        focus={focus}
        setFocus={(e) => setFocus(e)}
        name={name}
        placeholder={placeholder}
        rules={rules}
        isFieldDisabled={isFieldDisabled}
      />
    </div>
  );
};

const ReviewLocationModal = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const { reviewLocationModal, currentTrip } = useSelector(
    (state) => state.trips,
  );
  const { allLocations } = useSelector((state) => state.locations);

  const originalPosition = reviewLocationModal?.originalPosition ?? {};
  const recordedPosition = reviewLocationModal?.recordedPosition ?? {};
  const activityCount = reviewLocationModal?.activityCount ?? 0;

  const recordedTime = dayjs(reviewLocationModal?.recordedTime).format(
    "hh:mm A",
  );
  const distanceInMeters = L.latLng(originalPosition.lat, originalPosition.long)
    ?.distanceTo(L.latLng(recordedPosition.lat, recordedPosition.long))
    .toFixed(2);

  const existingLocation = allLocations.find(
    (location) =>
      originalPosition.lat === Number(location.lat) &&
      originalPosition.long === Number(location.long),
  );

  // get all the hubs
  const hubStations = useHubStationOnAdd();
  console.log({ hubStations });

  const existingHub = hubStations.find(
    (hub) =>
      hub.id === Number(existingLocation?.hubId ?? existingLocation?.hub_id),
  );

  const { control, formState, setValue, handleSubmit } = useForm({
    defaultValues: {
      name: "",
      latlng: "",
      hubName: "",
      hubId: existingHub?.id,
      activity: "",
    },
  });

  useEffect(() => {
    setValue("hubId", existingHub?.id ?? null);
  }, [existingHub?.id, setValue]);

  const [associateFarmers, setAssociateFarmers] = useState(false);

  const [focus, setFocus] = useState({
    name: false,
    latlng: false,
  });

  const heading = {
    1: "Review stop Location",
    2: "Modify Existing Location",
    3: "Add New Location",
  };

  const subHeading = {
    1: "The driver marked this as completed away from the registered location. Please review the actual location below:",
    2: "Are you sure you want to replace the existing stop coordinates with the newly detected location.",
    3: "Register this location as a separate stop for future trips.",
  };

  const locationOptions = [
    {
      id: 1,
      value: LOCATION_TYPE.COLLECTION,
      customField: getLocationType(LOCATION_TYPE.COLLECTION),
    },
    {
      id: 2,
      value: LOCATION_TYPE.DELIVERY,
      customField: getLocationType(LOCATION_TYPE.DELIVERY),
    },
    {
      id: 3,
      value: LOCATION_TYPE.AGGREGATION,
      customField: getLocationType(LOCATION_TYPE.AGGREGATION),
    },
  ];

  const locationName = existingLocation?.name;
  const hubName = existingHub?.value;

  // todo: to be discussed how to proceed with this

  const handleModifyExistingLocation = async () => {
    try {
      if (!existingLocation?.id) {
        console.error("Existing location ID not found.");
        return;
      }

      await client.put(
        `${process.env.REACT_APP_API_URL}/locations/${existingLocation.id}/coordinates`,
        {
          lat: recordedPosition.lat,
          long: recordedPosition.long,
        },
      );

      await dispatch(getAllLocationsV3());
      await dispatch(getGlobalLocations());
      await dispatch(getOverallSummary({ tripId: currentTrip.id }));
      await dispatch(getTripsV3());

      setStep(1);
      onCancel();
    } catch (error) {
      console.error(
        "Failed to modify existing location:",
        error?.response?.data || error.message,
      );
    }
  };

  const handleAddNewLocation = async (formData) => {
    try {
      if (!formData.name) {
        console.error("Location name is required.");
        return;
      }

      await client.post(
        `${process.env.REACT_APP_API_URL}/locations/add-new-location`,
        {
          name: formData.name,
          lat: recordedPosition.lat,
          long: recordedPosition.long,
          hub_id: formData.hubId || null,
          activity: formData.activity || null,
          associate_farmers: associateFarmers,
          existing_location_id: existingLocation.id,
          trip_id: currentTrip.id,
        },
      );

      await dispatch(getAllLocationsV3());
      await dispatch(getGlobalLocations());
      await dispatch(getOverallSummary({ tripId: currentTrip.id }));
      await dispatch(getTripsV3());

      setStep(1);
      onCancel();
    } catch (error) {
      console.error(
        "Failed to add new location:",
        error?.response?.data || error.message,
      );
    }
  };

  return (
    <CustomModal
      visible={visible}
      onCancel={() => {
        setStep(1);
        onCancel();
      }}
      width="375px"
    >
      <div
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-center justify-between px-6 pt-6">
          <div className="flex items-center gap-x-3">
            <p className="font-poppins font-medium text-base text-black">
              {heading[step]}
            </p>
          </div>

          <button
            type="button"
            className="mr-2"
            onClick={() => {
              setStep(1);
              onCancel();
            }}
          >
            <CloseIcon className="stroke-dark-gray w-6 h-6" />
          </button>
        </div>

        <div className="mt-4 px-6">
          <p className="font-aileron text-sm font-normal text-dark-gray cap">
            {subHeading[step]}
          </p>
        </div>

        {step < 3 && (
          <div className="mt-4 bg-background p-4 mx-4 items-center">
            <p className="font-poppins font-medium text-sm leading-none text-black capitalize">
              {locationName}
            </p>
            <div className="mt-4 border border-light-grey" />
            <div className="mt-4 space-y-2">
              {step === 1 && (
                <div className="flex justify-between">
                  <p className="font-aileron font-normal text-sm leading-none text-dark-gray">
                    Activities recorded
                  </p>
                  <p className="font-aileron font-semibold text-sm leading-none text-black">
                    {activityCount}
                  </p>
                </div>
              )}
              {step === 1 && (
                <div className="flex justify-between">
                  <p className="font-aileron font-normal text-sm leading-none text-dark-gray">
                    Timestamp
                  </p>
                  <p className="font-aileron font-semibold text-sm leading-none text-black">
                    {recordedTime}
                  </p>
                </div>
              )}
              <div className="flex justify-between">
                <p className="font-aileron font-normal text-sm leading-none text-dark-gray">
                  Expected location
                </p>
                <p className="font-aileron font-semibold text-sm leading-none text-black">
                  {`${originalPosition?.lat}, ${originalPosition?.long}`}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="font-aileron font-normal text-sm leading-none text-dark-gray">
                  Actual location
                </p>
                <p className="font-aileron font-semibold text-sm leading-none text-black">
                  {`${recordedPosition?.lat}, ${recordedPosition?.long}`}
                </p>
              </div>
              <div className="flex justify-end">
                <p className="font-aileron font-semibold text-sm leading-none text-yellow-dark">
                  {distanceInMeters} m away
                </p>
              </div>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="px-6 mt-4 space-y-6">
            <LabelAndInput
              label="Name"
              control={control}
              formState={formState}
              name="name"
              placeholder="Enter Name"
              // rules={{}}
              focus={focus.name}
              setFocus={(state) => setFocus({ ...focus, name: state })}
            />
            <div>
              <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
                Latitude, Longitude
              </p>

              <div className="h-10 px-3 flex items-center rounded border border-light-grey bg-background">
                <p className="font-aileron text-sm text-dark-gray">
                  {recordedPosition?.lat}, {recordedPosition?.long}
                </p>
              </div>
            </div>
            <div className="">
              <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
                Hub Station
              </p>

              <div className="h-10 px-3 flex items-center rounded border border-light-grey bg-background capitalize">
                <p className="font-aileron text-sm text-dark-gray">{hubName}</p>
              </div>
            </div>
            <div>
              <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
                Activity
              </p>
              <Controller
                name="activity"
                control={control}
                // rules={rules}
                render={({ field }) => (
                  <PopoverDropdown
                    {...field}
                    placeholder="Select Activity"
                    formState={formState}
                    options={locationOptions}
                    // eslint-disable-next-line react/no-unstable-nested-components
                    customValueRender={() =>
                      field.value ? (
                        getLocationType(parseInt(field.value, 10))
                      ) : (
                        <p>Select Activity</p>
                      )
                    }
                    valueStyle={{ width: "327px" }}
                    contentContainerStyle={{ width: "327px" }}
                    onSelect={(data) => {
                      setValue("activity", data.value);
                    }}
                  />
                )}
              />
            </div>
            <div className="flex justify-between -mt-2">
              <p className="font-aileron font-normal text-sm leading-none text-dark-gray">
                Associate all farmers whose activities were recorded to new
                location.
              </p>
              <input
                type="checkbox"
                checked={associateFarmers}
                onChange={(e) => setAssociateFarmers(e.target.checked)}
                className="w-4 h-4 cursor-pointer rounded-md border border-light-grey accent-[#0A6870]"
              />
            </div>
          </div>
        )}

        {step === 1 && (
          <div className="flex justify-between gap-x-3 p-6">
            <Button
              colors="mobilizePrimary"
              width="reviewLocation"
              onClick={() => setStep(3)}
            >
              Add New Location
            </Button>
            <Button
              colors="primary"
              width="reviewLocation"
              onClick={() => setStep((prev) => prev + 1)}
            >
              Modify Existing
            </Button>
          </div>
        )}
        {step === 2 && (
          <div className="flex justify-between gap-x-3 p-6">
            <Button
              colors="cancelButton"
              width="reviewLocation"
              onClick={() => {
                setStep(1);
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              colors="primary"
              width="reviewLocation"
              onClick={handleModifyExistingLocation}
            >
              Modify Existing
            </Button>
          </div>
        )}
        {step === 3 && (
          <div className="flex justify-between gap-x-3 p-6">
            <Button
              colors="cancelButton"
              width="reviewLocation"
              onClick={() => {
                setStep(1);
                onCancel();
              }}
            >
              Cancel
            </Button>

            <Button
              colors="primary"
              width="reviewLocation"
              onClick={handleSubmit(handleAddNewLocation)}
            >
              Add New Location
            </Button>
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default ReviewLocationModal;
